import { styled } from '@mui/material/styles';

import { Footer } from '../../../';

export const FooterStyled = styled(Footer)({
	'&.mobile': { borderRadius: '16px 16px 0 0' },
});
